import { flexRender, type RowData } from "@tanstack/react-table";

import { ColumnResizeHandle, type IColumnsSizingStore } from "@ryde/controls";
import { getHeaderClassName, type IRydeHeader } from "@ryde/shared";

import { TableHeaderCellReportStyled } from "./header.cell.reports.styled";
import { useGridTableHeadCellReports } from "./use-grid-table-head-cell-reports";

interface IGridRowHeadCellProps<T extends RowData> {
  header: IRydeHeader<T, unknown>;
  isTableSized: boolean;
  columnsSizingStore: IColumnsSizingStore;
}

export const GridTableHeadCellReports = <T extends RowData>({
  header,
  isTableSized,
  columnsSizingStore,
}: IGridRowHeadCellProps<T>): JSX.Element => {
  const { columnId, columnLabel, columnWidth, isResizable } =
    useGridTableHeadCellReports({ header, isTableSized });

  return (
    <TableHeaderCellReportStyled
      key={header.id}
      colSpan={header.colSpan}
      className={getHeaderClassName(header)}
      data-column-id={columnId}
      $columnWidth={columnWidth}
    >
      {header.isPlaceholder ? null : (
        <div className="th_content">
          {flexRender(header.column.columnDef.header, header.getContext())}
        </div>
      )}
      {isResizable && (
        <ColumnResizeHandle
          columnId={columnId}
          columnLabel={columnLabel}
          columnWidth={columnWidth}
          columnsSizingStore={columnsSizingStore}
        />
      )}
    </TableHeaderCellReportStyled>
  );
};
